import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ContactPage.css';

function ContactPage() {
    return (
        <section className="contact-page">
            <div className="container-fluid p-0">
                <header className="position-relative">
                    <img src="/images/aboutimg.svg" alt="Contact Us" className="img-fluid w-100 header-image" />
                    <div className="header-text position-absolute top-50 start-50 translate-middle p-4 text-center">
                        <h1 className="mt-4 w-100 text-white">Get in Touch with Us</h1>
                        <p className="text-white w-100 text-center">Have a question, comment, or feedback? We'd love to hear from you!</p>
                    </div>
                </header>
                <div className="row">
                    <div className="col-md-5 contact-info mt-5 mx-auto">
                        <h2 className="text-center text-dark">Contact Information</h2>
                        <p className="text-center mb-1 text-dark">You can reach us through the following channels:</p>
                        <ul className="list-unstyled text-left text-dark">
                            <li>
                                <img src="/images/house.svg" alt="Mail" className="social-icon" /> 123 Main St, Anytown, USA 12345
                            </li>
                            <li>
                                <img src="/images/phone-icon.svg" alt="Mail" className="social-icon" /> +1 800 123 4567
                            </li>
                            <li>
                                <img src="/images/email.svg" alt="Mail" className="social-icon" /> <a href="mailto:info@example.com">info@example.com</a>
                            </li>
                        </ul>
                    </div>
                    <div className="col-md-5 contact-form mt-5 mx-auto">
                        <h2 className="text-center text-dark">Send Us a Message</h2>
                        <p className="text-center mb-1 text-dark">Fill out the form below to send us a message:</p>
                        <form>
                            <div className="form-group">
                                <label for="name">Name</label>
                                <input type="text" id="name" className="form-control" />
                            </div>
                            <div className="form-group">
                                <label for="email">Email</label>
                                <input type="email" id="email" className="form-control" />
                            </div>
                            <div className="form-group">
                                <label for="message">Message</label>
                                <textarea id="message" className="form-control"></textarea>
                            </div>
                            <div className="text-center">
                                <button type="submit" className="btn btn-primary">Send Message</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ContactPage;